import React from "react";
import { Link } from "react-router-dom";
import firebase from "../firebase";

interface HeaderProps {
  user: any;
}

export const AppHeader: React.FC<HeaderProps> = ({ user }) => {
  return (
    <header className="header">
      <img
        src="/assets/images/logo.png"
        alt="logo"
        style={{ height: "40px", display: "flex", alignItems: "center" }}
      />
      <nav className="nav">
        <Link to="/home">Home</Link>
        <Link to="/new">New</Link>
        {user ? (
          <a
            href="#logout"
            style={{ marginLeft: 16, color: "#c00", fontWeight: 500 }}
            onClick={e => {
              e.preventDefault();
              firebase.auth().signOut();
            }}
          >
            Logout
          </a>
        ) : (
          <Link
            to="/login"
            style={{ marginLeft: 16, color: "#2563eb", fontWeight: 500 }}
          >
            Login
          </Link>
        )}
      </nav>
    </header>
  );
};
